import * as React from 'react'
import styled from 'styled-components'
import { Input } from '../plugins/casting/casting-styled.component'
import LongPressComponent from './long-press.component'

const StepperInput = styled.div`
  display: flex;
`

const InputMiddle = styled(Input)`
  flex-grow: 1; 
  text-align: center;
  -webkit-appearance: none;
  border-right: none;
  border-left: none;
  border-radius: 0;
  padding: 0.75em;
  text-align: center !important;
`

const SideButton = styled.button<{ $side: 'left' | 'right' }>`
  min-width: 2.5em; 
  padding: 0.550em;
  font-weight: bold;
  font-size: 1.0em;
  border: 1px solid ${ props => props.theme.colors.clr_0 };
  background-color: #fff;
  box-shadow: none;
  border-radius: ${ props => props.$side == 'left' ? '0.375em 0 0 0.375em' : '0 0.375em 0.375em 0' };

  &:hover {
    color: #fff;
    border: 1px solid ${ props => props.theme.colors.clr_1 };
    background-color: ${ props => props.theme.colors.clr_1 };
  }
`

interface Props {
  name: string
  value: number
  onChange: (value: number) => void
  min: number
  max: number
  step?: number
  formatter: (value: number) => string
  style?: React.CSSProperties
}

interface State {
  formattedValue: string
}

export default class StepperInputComponent extends React.Component<Props, State> {
  static defaultProps = { step: 1 }
  state: State = { formattedValue: this.props.formatter(this.props.value) }

  componentDidUpdate (prevProps: Props) {
    if (prevProps.value !== this.props.value) this.setState({ formattedValue: this.props.formatter(this.props.value) })
  }

  private incrementValue () {
    const newValue = this.props.value + this.props.step
    if (newValue > this.props.max) return
    this.props.onChange(newValue)
  }

  private decrementValue () {
    const newValue = this.props.value - this.props.step
    if (newValue < this.props.min) return
    this.props.onChange(newValue)
  }

  /*
    The value rendered in the text file is not a number.
    When edited, we try to parse the number from the formatted string.
    This method checks if the string format allows 'safely' to parse the value from the formatted input by performing some tests.
  */
  private isSafeDirectEditable () {
    if (this.props.formatter) return false

    for (const i of [-10, 0, 0.5, 10, 25, 50, 100]) {
      if (parseInt(this.props.formatter(i), 10) !== i) return false
    }

    return true
  }

  private onBlur () {
    if (!this.isSafeDirectEditable()) return
    let value = parseInt(this.state.formattedValue, 10)

    if (isNaN(value)) {
      this.setState({ formattedValue: this.props.formatter(this.props.value) })
    } else {
      if (value > this.props.max) value = this.props.max
      if (value < this.props.min) value = this.props.min
      this.props.onChange(value)
    }
  }

  render () {
    const { props: { style, name }, state: { formattedValue } } = this

    return <StepperInput style={ style } id={ `js-test-${name}` }>
      <LongPressComponent onLongPress={ () => this.decrementValue() }>
        <SideButton $side="left" type="button" onClick={ () => this.decrementValue() }>-</SideButton>
      </LongPressComponent>

      <InputMiddle value={ formattedValue } onChange={ event => this.setState({ formattedValue: event.target.value }) } onBlur={ () => this.onBlur() } readOnly={ !this.isSafeDirectEditable() } />

      <LongPressComponent onLongPress={ () => this.incrementValue() }>
        <SideButton $side="right" type="button" onClick={ () => this.incrementValue() }>+</SideButton>
      </LongPressComponent>
    </StepperInput>
  }
}
